import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { DateTimeHelper } from '../../../../utils/DateTimeHelper.util'
import {BMListingViewModel} from '../../../../models/bm'
import {BM_GET_BM, BM_MODULE_NAMESPACE, BM_RESET_BM_MEETINGS} from "../../../../store/building-monitor/bm-types.store";
import {namespace} from "vuex-class";
const BMStore = namespace(BM_MODULE_NAMESPACE)

@Component
class BMListItem extends Vue {

  constructor () {
    super()
  }
  @Prop({ default: {}, type: [Object] })
  bm: BMListingViewModel;

  @BMStore.Mutation(BM_GET_BM)
  storeSetBM: (bm: any) => void;

  mounted () {}

  get lblSetting () {
    return {
      ...require('@/locales/generic-labels').default,
      ...require('@/locales/building-monitor').default,
      ...require('@/locales/ticket').default
    }
  }
  get coChannelLink (): string {
    return `/bm/${this.bm.id}`
  }
  get coBlockName (): string { return this.bm.block.name }
  get coAddress (): string {
    return `${this.bm.block.address.line1} ${this.bm.block.address.line2} ${this.bm.block.address.zip_code} ${this.bm.block.address.city} `
  }
  get coNextMeetingDate () {
    if (!this.bm.meetings || this.bm.meetings.length <= 0) return this.$t(this.lblSetting.bmNoMeeting)
    let d1 = new Date()
    let d2 = new Date(this.bm.meetings[0].date_start)
    if (d1 > d2) return this.$t(this.lblSetting.bmLastMeeting) + DateTimeHelper.parseDateTimeCalendarUTC(this.bm.meetings[0].date_start)
    return this.$t(this.lblSetting.bmNextMeeting) + DateTimeHelper.parseDateTimeCalendarUTC(this.bm.meetings[0].date_start)// this.bm.nb_ko_item;
  }
  get coCreatedAt (): string {
    return DateTimeHelper.parseDateTimeCalendar(this.bm.createdAt)
  }
  get coCreatedBy (): string {
    return [this.bm.creator.firstname || '', this.bm.creator.lastname || ''].join(' ')
  }
  get coBuildingGoal (): string {
    return DateTimeHelper.parseDate(this.bm.date_end_building)
  }
  get coBuildingStart (): string {
    return DateTimeHelper.parseDate(this.bm.date_start_building)
  }
  get coBMName (): string {
    return 'SDC - ' + this.bm.block.name + (this.bm.apartment ? (' - ' + this.bm.apartment.apartment_number) : '')
  }
  clickItem() {
    this.storeSetBM(this.bm)
  }
}

export default BMListItem



// WEBPACK FOOTER //
// ./src/containers/building-monitor/components/building-monitor-list-item/index.ts